import { render, staticRenderFns } from "./utiles-detalles-publicacion-descripcion.vue?vue&type=template&id=746da08b&scoped=true&"
import script from "./utiles-detalles-publicacion-descripcion.vue?vue&type=script&lang=ts&"
export * from "./utiles-detalles-publicacion-descripcion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746da08b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSkeletonLoader,VTextarea})
